import type { BusinessContactFields } from './contact-message';

export type ContactFormResult = 'success' | 'invalid' | 'rateLimit' | 'error';

export async function submitContactForm(
  fields: BusinessContactFields,
  sessionId: string
): Promise<ContactFormResult> {
  try {
    const response = await fetch('/api/contact', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...fields, sessionId }),
    });
    if (response.status === 429) return 'rateLimit';
    if (response.status === 400) return 'invalid';
    if (!response.ok) return 'error';
    const result: unknown = await response.json();
    return result &&
      typeof result === 'object' &&
      'success' in result &&
      result.success === true
      ? 'success'
      : 'error';
  } catch {
    return 'error';
  }
}
